export default "__VITE_ASSET__qFyjdUQB__"